<template>
  <div class="wrapper">
    <div class="text-center mt-4 mx-2">
      <img
        src="@/assets/page1/Asset1.png"
        alt="Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <!-- Animated Element -->
    <div
      class="text-center mt-4 mx-2 animated-banner"
    >
      <img
        src="@/assets/page2/Asset 8.png"
        alt="Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <div class="text-center mt-4 mx-2">
      <img
        src="@/assets/page2/Asset 17.png"
        alt="Banner"
        class="img-fluid mx-auto d-block"
      />
    </div>

    <!-- Start Button -->
    <div class="text-center mt-5 lower-panner">
      <img
        src="@/assets/page2/start.png"
        alt="Start Button"
        class="img-fluid mx-auto d-block start-btn hover"
        @click="navigateToNext"
      />
    </div>

    <!-- Footer Navigation -->
    <!-- <FooterNavigation :nextRoute="'/vaccination'" /> -->
  </div>
</template>

<script setup>
// import FooterNavigation from "@/components/FooterNavigation.vue";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

const router = useRouter();
const navigateToNext = () => {
  router.push("/vaccination");
};

// Add a state for triggering the animation
const isAnimated = ref(false);
onMounted(() => {
  isAnimated.value = true; // Start the animation when the component is mounted
});
</script>
<style scoped>
/* Page Container */
.main-panner {
  width: 100%;
}

.lower-panner {
  margin-bottom: 8rem;
}

/* Shadow Effect for Start Button */
.start-btn {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}
.start-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Animation for the Middle Image */
.animated-banner {
  animation: glow-fade 2s ease-in-out forwards, float 4s ease-in-out infinite;
  transform-origin: center;
}

@keyframes glow-fade {
  0% {
    opacity: 0;
    transform: scale(0.5);
    filter: blur(10px);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
    filter: blur(4px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px); /* Increased float effect */
  }
}
</style>
